// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

const PgNotificationLogsController = function ($scope, $http, $location, PgNotificationLogs) {
    $scope.loading = true;

    $scope.logLevels = [];
    
    $scope.notificationLogs = [];

    const getEmptyFilter = function () {
        return {
            Level: '',
            Message: '',
            After: '',
            Before: '',
            PaymentProvider: '',
            RetryJobId: '',
        };
    };

    $scope.filter = getEmptyFilter();

    $scope.loadPage = function () {
        let queryParams = $location.search();
        if (queryParams.PspReportId) 
            $scope.filter.PspReportId = queryParams.PspReportId;
        
        $http.get('/api/v1/paymentGateway/logs/loglevels', {cache: true}).then(function (result) {
            $scope.logLevels = result.data;
        });

        $http.get('/api/v1/paymentGateway/transactions/PaymentProviders', {cache: true}).then(function (result) {
            $scope.paymentProviders = result.data;
        });        
    }

    $scope.loadPage();

    $scope.fetchNotificationLogs = function () {
        let queryParams = $location.search();
        if (queryParams.PspReportId)
            $scope.filter.PspReportId = queryParams.PspReportId;
        
        $scope.loading = true;
        $scope.notificationLogs = $scope.paginator(function(options, callback) {
                return PgNotificationLogs.query(options, function()
                {
                    callback();
                    $scope.loading = false;
                });
            },
            $scope.filter,
            100);

        if ($scope.filter.PspReportId)
            queryParams["PspReportId"] = $scope.filter.PspReportId;
        
        $location.search(queryParams)
    }

    $scope.fetchNotificationLogs();

    $scope.resetFilter = function () {
        $scope.filter = getEmptyFilter();
        $location.url($location.path());
    };
};
PgNotificationLogsController.$inject = ["$scope", "$http", "$location", "PgNotificationLogs"];
